












































































































































































































import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import AuditAdjustCreate from "@/views/jm/jobdo/totalreport/audit-adjust-create.vue";
import elementResizeDetector from "element-resize-detector";
@Component({
components:{AuditAdjustCreate}
})

export default class AuditAdjustMentView extends AbpBase {
    loadingInstance:boolean=false;
    loading:boolean=false;
    calcing:boolean=false;
    showEmpty=false;
    adjustShow:boolean=false;
    WinH=window.innerHeight-110;
    rowStyleOption={
           clickHighlight: false,
           hoverHighlight: true,
    };
    formatCurrency (num) {
      return Util.format.amount(num);
    }
    formatRate(num){
      return Util.format.rate(num);
    }
    get jobauth(){
       let d= this.$store.state.jobdo.roles;
       if(d.length>0){
          return d[0].checked=='1'?true:false;
       }
       return false;
    }
    value="3";
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(row.id=='0'||row.id=='-1'||row.id=='-4'){
        if(columnIndex==0){
          return [1, 11];
        } 
        else{
          return [0, 0];
        }
      }
      if(row.id==='-3'){
        if(columnIndex===0){
          return [1, 3];
        }
        else if(columnIndex<3){
          return [0, 0];
        }
      }
    }
    tableRowClassName({row,rowIndex}) {
        if (row.id==='0') {
          return 'typehead';
        }
        if (row.id==='-1') {
          return 'typeline';
        }
        if (row.id==='-2') {
          return 'typesum';
        }
        if(row.id==='-3'){
          return 'typetotal';
        }
        if(row.id==='-4'){
          return 'typeempty';
        }
         return '';
      }
    @Watch('value')
    async selectChange(){
      await this.getdata();
    };
    addadjust(){
      this.adjustShow=true;
      setTimeout(() => { 
          let addview:any=this.$refs.adjustref;
          addview.handleAdd("0");
          addview.handleAdd("0");
        }, 100); 
    }
    editadjust(row){
      if(row.headId){
        this.adjustShow=true;
        setTimeout(() => { 
          let edit:any=this.$refs.adjustref;
          edit.setModalId(row.headId);
        }, 100); 
      }
    }
  async checkadjust(row){
      if(row.headId&&row.adjType){
      var currid=this.$store.state.jobdo.currjob;
      this.calcing=true;
        let reponse=await this.$store.dispatch({
          type:'fsadjustline/checkitem',
          data:{Id:row.headId,ProjectId:currid,AdjType:row.adjType}
        });
        if(reponse.success){
          this.$message({
                message: '调整成功',
                type: 'success'
          });
          await this.getdata();
        }
        this.calcing=false;
      }
    }
    async canceladjust(row){
      if(row.headId&&row.adjType){
       this.calcing=true;
      var currid=this.$store.state.jobdo.currjob;
        let reponse=await this.$store.dispatch({
          type:'fsadjustline/cancelitem',
          data:{Id:row.headId,ProjectId:currid,AdjType:row.adjType}
        });
        if(reponse.success){
          this.$message({
                message: '取消成功',
                type: 'success'
          });
          await this.getdata();
        }
        this.calcing=false;
      }
    }
    get isleader(){
        let data= this.$store.state.jobdo.roles;
        if(data.length>0){
            var role=data[0].userRole;
            return Util.format.roleLeader(role)
        }
        return false;
    }
    get ismember(){
        let data= this.$store.state.jobdo.roles;
        if(data.length>0){
            var role=data[0].userRole;
            return Util.format.roleMember(role)
        }
        return false;
    }
    get list(){
        var data=this.$store.state.fsadjustline.line3;
        return data;
    };
    get line(){
      var data=this.$store.state.fsadjustline.line;
        return data;
    }
    async getdata(){
      let currid=this.$store.state.jobdo.currjob;
      this.loadingInstance=true;
      let type=this.value;
      if(type=='3'){
        await this.$store.dispatch({
          type:'fsadjustline/getlist3',
          data:currid
        })
      }
      else{
        await this.$store.dispatch({
          type:'fsadjustline/getlist',
          data:{'Id':currid,'Value':type}
        })
      }
      this.loadingInstance=false;
    };
    
   async created(){
      await this.getdata();
    }
    mounted() {   
      const that = this;
        var erd = elementResizeDetector();
        erd.listenTo(document.getElementsByClassName("el-table"), (element) => {   
        that.$nextTick(() => { 
           that.WinH=window.innerHeight-110;
          });
        });      
   }
    async exportxls(){
      let currid=this.$store.state.jobdo.currjob;
      this.loading=true;
      await this.$store.dispatch({
          type: "fsadjustline/download",
          data: {projectid:currid,filename:'审计调整汇总.xlsx'}
      });
      this.loading=false;
    }   
    
}
